module.exports = "/images/_/_/_/_/api.acadevian.com/resources/js/src/assets/images/profile/post-media/25.jpg";